const taskProcessType =[
    {
        id:0,
        label:'Automatic'
    },
    {
        id:1,
        label:'Manual'
    },
]

const taskExecutionResult =[
    {
        label: 'Error',
        color1: 'color-6',
        color2: 'lightest',
        id: -1
    },
    {
        label: 'Undefined',
        color1: 'dark',
        color2: 'darker',
        id: 0
    },
    {
        label: 'Success',
        color1: 'color-3',
        color2: 'lightest',
        id: 1
    },
    {
        label: 'Warning',
        color1: 'color-5',
        color2: 'lightest',
        id: 2
    },
]

const taskStates =[
    {
        label: 'Running',
        color1: 'color-3',
        color2: 'lightest',
        id: -1
    },
    {
        label: 'Inactive',
        color1: 'color-6',
        color2: 'lightest',
        id: 0
    },
    {
        label: 'Active',
        color1: 'color-3',
        color2: 'lightest',
        id: 1
    },
    {
        label: 'Terminated',
        color1: 'dark',
        color2: 'darker',
        id: 100
    },
]

const typeOptions =[
    {
        label: 'Invoice',
        id: 10000
    },
    {
        label: 'Other',
        id: 0
    },
]

const repetitionOptions = [
    {
        label: 'Weekly',
        id: 1
    },
    {
        label: 'Monthly',
        id: 2
    }
]

const weekDayOptions = [
    {
        label: 'Monday',
        id: 1,
    },
    {
        label: 'Tuesday',
        id: 2,
    },
    {
        label: 'Wednesday',
        id: 3,
    },
    {
        label: 'Thursday',
        id: 4,
    },
    {
        label: 'Friday',
        id: 5,
    },
    {
        label: 'Saturday',
        id: 6,
    },
    {
        label: 'Sunday',
        id: 0,
    },
]

const monthDayOptions = [
    {
        label: '1',
        id: 1,
    },
    {
        label: '2',
        id: 2,
    },
    {
        label: '3',
        id: 3,
    },
    {
        label: '4',
        id: 4,
    },
    {
        label: '5',
        id: 5,
    },
    {
        label: '6',
        id: 6,
    },
    {
        label: '7',
        id: 7,
    },
    {
        label: '8',
        id: 8,
    },
    {
        label: '9',
        id: 9,
    },
    {
        label: '10',
        id: 10,
    },
    {
        label: '11',
        id: 11,
    },
    {
        label: '12',
        id: 12,
    },
    {
        label: '13',
        id: 13,
    },
    {
        label: '14',
        id: 14,
    },
    {
        label: '15',
        id: 15,
    },
    {
        label: '16',
        id: 16,
    },
    {
        label: '17',
        id: 17,
    },
    {
        label: '18',
        id: 18,
    },
    {
        label: '19',
        id: 19,
    },
    {
        label: '20',
        id: 20,
    },
    {
        label: '21',
        id: 21,
    },
    {
        label: '22',
        id: 22,
    },
    {
        label: '23',
        id: 23,
    },
    {
        label: '24',
        id: 24,
    },
    {
        label: '25',
        id: 25,
    },
    {
        label: '26',
        id: 26,
    },
    {
        label: '27',
        id: 27,
    },
    {
        label: '28',
        id: 28,
    },

]


export default {
    typeOptions,
    repetitionOptions,
    weekDayOptions,
    monthDayOptions,
    taskStates,
    taskExecutionResult,
    taskProcessType
}



// WEBPACK FOOTER //
// ./src/store/modules/scheduledTasks/scheduledTasksStatic.js